import type { VideoResult, TranscriptAnalysis } from '../../types';
import { ScoreRing } from '../../primitives';
import { AgentLabel, MetaPill, sentenceCase } from '../../shared';

interface FlagColors {
  text: string;
  bg: string;
  border: string;
}

interface BrandSafetyAgentPanelProps {
  video: VideoResult;
  ta: TranscriptAnalysis | undefined;
  flagColors: FlagColors;
  bannedCount: number;
  sensitiveCount: number;
  brandSafetyText: string;
}

export function BrandSafetyAgentPanel({
  video,
  ta,
  flagColors,
  bannedCount,
  sensitiveCount,
  brandSafetyText,
}: BrandSafetyAgentPanelProps) {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #E5E5E5',
        borderRadius: 8,
        padding: 18,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <AgentLabel>TRANSCRIPT SAFETY</AgentLabel>
      <div style={{ display: 'flex', gap: 16 }}>
        {ta && (
          <ScoreRing
            score={ta.transcript_safety_score}
            size={92}
            numberSize={16}
            numberWeight={600}
            numberColor="#171717"
            labelSize={12}
          />
        )}
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            <MetaPill
              label={sentenceCase(video.flag)}
              bg={flagColors.bg}
              border={flagColors.border}
              color={flagColors.text}
              dot={flagColors.text}
            />
            {bannedCount > 0 && (
              <MetaPill label={`${bannedCount} banned kw`} bg="#FBEAEA" border="#FBEAEA" color="#B53636" />
            )}
            {sensitiveCount > 0 && (
              <MetaPill label={`${sensitiveCount} sensitive`} bg="#FCF1E3" border="#FCF1E3" color="#A5650A" />
            )}
          </div>
          {brandSafetyText && (
            <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#404040', lineHeight: 1.6 }}>
              {brandSafetyText}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
